export default __webpack_public_path__ + "static/media/Bull.6990e21b.png";